import React, { useState } from 'react';
import { ArrowUpRight, ArrowRight } from 'lucide-react';

export default function Services() {
  const [activeIndex, setActiveIndex] = useState(0);

  const services = [
    {
      title: "Marketing Technologies",
      description: `We deliver special projects that drive engagement and results through cutting-edge marketing technologies. Powered by AI, guided by data, and deeply connected to your brand’s purpose. From predictive insights to personalized journeys, we develop future-forward experiences that are not only innovative but intentional. 

We work on projects like AI-generated content engines, purpose-driven recommendation models, adaptive brand experiences, and real-time feedback loops, always with a human lens. Our approach blends emerging tech with creative strategy to help brands grow with relevance and real impact.`,
    },
    {
      title: "360° Brand Activations",
      description: `We design integrated brand experiences that connect seamlessly across platforms and environments. Online, offline, physical, digital, and often phygital (where the two converge). Every activation is purpose-built to do more than just capture attention: it’s crafted to evoke emotion, spark interaction, and align with your larger brand strategy.

From street-level pop-ups and immersive installations to XR-led moments and data-driven creations, we go for experiences that resonate. Our goal is to meet today’s audiences where they are. Curious, connected, and craving experiences they can feel, not just scroll past.`,
    },
    {
      title: "Visual Communication Design",
      description: `Our in-house visual team translates strategy into bold, coherent design systems that connect across every touchpoint. We build from the brand core (logos, typography, color systems, and guidelines) and extend into campaign visuals, social-first kits, editorial storytelling, and digital layouts built for scale.

Whether you’re launching something new or evolving what exists, we design with precision and purpose. Always balancing creativity with clarity, and always tuned into cultural and design trends to make sure you stay relevant in real time. Every asset we create is made to move: across platforms, across markets, and in sync with your audience’s expectations.`,
    },
    {
      title: "Motion Graphics & Production",
      description: `We understand that next-gen content has to move to attract and perform to matter. RealTeam’s motion graphic designers handles the full pipeline: concepting, scripting, shooting, animation, editing, and sound.

We create brand films with narrative depth, animated explainers that simplify the complex, scroll-stopping social motion packs, modular video toolkits for multi-channel use, and high-impact assets for launches, keynotes, and events. We craft content that’s format-aware, audience-specific, and ready to work hard wherever it lands, whether it’s live action, motion graphics, 2D/3D animation, or mixed media.`,
    },
    {
      title: "Digital Community Management & Social Media",
      description: `We treat social media as a space where people gather, share, react, and connect. Managing a brand here means more than showing up with scheduled posts. It means understanding the rhythm of each platform, being present in the right way, and having something worth saying. 

Our social media geniuses take care of everything behind the scenes: strategy, content creation, publishing, moderation, reporting. So your brand can show up consistently and with purpose. We pay attention to what your audience actually cares about, what the platform algorithms favor, and how culture is shifting in real time. It's always a mix of listening and leading. And over time, that's what builds a real community, not just a following.`,
    },
  ];

  return (
    <section className="w-full  bg-white" id = "services">
    <div className="max-w-[1600px] mx-auto px-4 sm:px-6">
      <h2 className="text-[40px] sm:text-[60px] md:text-[80px] font-questrial mb-16 mt-16 font-normal text-[#22282B]">
        Services
      </h2>
  
      {services.map((service, index) => (
        <div
          key={index}
          className="mb-10 border-b border-gray-300 pb-6"
        >
          {/* Başlık alanı */}
          <div
            onClick={() => setActiveIndex(index)}
            className="flex justify-between items-center cursor-pointer"
          >
            <div className="flex items-center space-x-4">
              <span
                className={`text-3xl sm:text2xl font-questrial ${
                  activeIndex === index ? 'text-[#CE65FF]' : 'text-[#22282B]'
                }`}
              >
                0{index + 1}
              </span>
              <h3
                 className={`text-3xl sm:text-[28px] md:text-[40px] font-Questrial font-normal transition-all ${
                  activeIndex === index ? 'text-[#CE65FF]' : 'text-[#22282B]'
                }`}
              >
                {service.title}
              </h3>
            </div>
  
            <div
              className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 rounded-full transition-all ${
                activeIndex === index
                  ? 'border-[#C778DD] text-[#C778DD]'
                  : 'border-black text-black'
              }`}
            >
              {activeIndex === index ? <ArrowUpRight /> : <ArrowRight />}
            </div>
          </div>
  
          {/* Açıklama kutusu */}
          {activeIndex === index && (
            <div className="mt-6 bg-[#22282B] text-white text-base sm:text-lg leading-relaxed px-6 sm:px-10 py-8 sm:py-12 rounded-2xl">
              {service.description.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  </section>
  
  );
}
